import React from "react";
import "./Loader.scss";

export default () => (
  <div className="loader-wrapper">
    <div className="loader" />
  </div>
);
